<!-- =========================================================================================
    File Name: ProjectsWorkerItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 pt-6 pb-10" :class="{'mail__opened-mail': !task.unread}">

        <div class="flex w-full">
            <div class="flex w-full justify-between items-start">
                <div class="mail__details">
                    <div class="flex">
                      <h5 class="font-semibold mt-1">{{ task.Task }}</h5>  

                      <vs-chip v-if="task.DetailsURL != null" class="ml-3 cursor-pointer"><vs-avatar @click="ViewDetails()" icon-pack="feather" icon="icon-link" /><span @click="ViewDetails()">View Details</span>
                      </vs-chip>
                    </div>

                    {{ task.WorkerName }}
                </div>

                <div class="mail-item__meta flex items-center">
                    <div class="email__labels hidden sm:flex items-center">
                        <div class="h-2 w-2 rounded-full mr-2" v-for="(label, index) in task.labels" :key="index"></div>
                    </div>

                    <vs-progress :percent="GetBarPercent(task)" :color="GetBarColor(GetBarPercent(task))"></vs-progress>
                        <span>{{task.ActualHours}} out of {{task.EstimatedHours}} hours</span>
                    <div>
                      <div class="flex">
                        <span style="width: 65px"></span> <!--White space where mark complete button should go -->
                        <!-- <vs-button :disabled="!CanClockIn" type="relief" vs-type="flat" size="small" color="primary" icon="check">Mark Complete</vs-button> -->
                        <!-- <vs-button :disabled="!CanClockIn" type="relief" vs-type="flat" size="small" color='success' icon="timer" class="mx-2" @click="ClockIn()">Clock In</vs-button> -->
                      </div>
                      <div class="mt-2 taskItemProgress">
                        
                      </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="w-full">
            <div class="flex items-center">
            </div>
            <div class="taskItemDetails">
                {{ task.TaskDetails }}
            </div>
            <!-- <div class="taskItemLink" v-if="task.DetailsURL != null">
              <vs-button color='success' type="border" icon="link" size="small" class="mt-2" @click="ViewDetails()">Details</vs-button>
            </div> -->
        </div>


    </div>
</template>

<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const moment = require('moment') // require


export default {
  components:{
    flatPickr,
    'v-select': vSelect
  },
  props: {
    task: {
      type: Object,
      required: true
    },

    currentTask:null
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    ProjectList () {
      return this.$store.getters.GetProjectList
    },
    CanClockIn () {
      if (this.currentTask == this.task) {
        return false
      } else {
        return true
      }
    },
    currentTimeEntry () {
      return this.$store.getters.GetCurrentTimeEntry
    }
    
  },
  methods: {
    ViewDetails () {
      window.open(this.task.DetailsURL, '_blank')
    },
    GetBarPercent (task) {
      const r = task.ActualHours / task.EstimatedHours * 100
      return r
    },
    GetBarColor (percent) {
      if (percent <= 80) {
        return 'success'
      } else if (percent <= 100) {
        return 'warning'
      }
      return 'danger'
    },
    GetProjectCategoryID (projectID) {
      return this.ProjectList.find(x => x.ProjectID == projectID).CategoryID
    },
    ClockIn () {
      if (this.currentTimeEntry == null) {
        const currentTime = moment().format('hh:mm A')
        const currentDate = moment().format('Y-MM-DD')
        console.log(this.task)
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: this.task.Task,
          taskID: this.task.TaskID,
          clientName: this.task.ClientName,
          clientID: this.task.ClientID,
          projectID: this.task.ProjectID,
          categoryID: this.GetProjectCategoryID(this.task.ProjectID),
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          endTime: null,
          endDate: null,
          description: '',
          error: 'Fields cannot be empty.',
          action: 'clockin', //create, clockin, finish
          mileage: 0,
          sowID: null,
          sowLineItemID: null,
        })
      } else {
        this.$emit('ChildClockIn', this.task)
      }
      
    }
  }
}

</script>

